import AppStandardButton from "../../components/UI/AppButtons";
import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { useLocation } from "react-router-dom";
import { BookingApi } from "../../API/Apis/BookingApi";
import { NexiChargeTransactionDetails } from "../../@types/Booking/nexiTransactionDetails";
import BookingGetters from "../../store/onlineBooking/getters";
import TagManager from "react-gtm-module";
import { AppSettingResponse } from "../../@types/DTO/AppSetting";

export function BookingConfirmPage() {
  const appSettings = BookingGetters.getAppSettings();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const importo = searchParams.get("importo") || "";
  const price = Number(importo) / 100;
  const num_contratto = searchParams.get("codTrans") || "";
  const dbId = num_contratto.split("RES_")[1];
  const [showGtagManagerEvent, setGtagManagerEvent] = useState(
    appSettings?.gtagManagerEvent || ""
  );
  const [showGTagManagerSendTo, setGTagManagerSendTo] = useState(
    appSettings?.gTagManagerSendTo || ""
  );
  const [showGTagManagerCurrency, setGTagManagerCurrency] = useState(
    appSettings?.gTagManagerCurrency || ""
  );
  const isSmallScreen = window.innerWidth <= 768;
  const [isTagManagerDataLayerEnabled, setIsTagManagerDataLayerEnabled] =
    useState(false);
  const [showGtagManagerValue, setGtagManagerValue] = useState(false);
  const [showGTagManagerTransactionId, setGTagManagerTransactionId] =
    useState(false);
  const [tagManagerId, setTagManagerId] = useState("");
  const [isTagManagerEnabled, setIsTagManagerEnabled] = useState(false);
  const showPrice = showGtagManagerValue ? price : null;
  const showDbId = showGTagManagerTransactionId ? dbId : null;

  const applyTagManagerSettings = (settings: AppSettingResponse) => {
    setIsTagManagerDataLayerEnabled(!!settings.enableDataLayer);
    setGTagManagerCurrency(settings.gTagManagerCurrency || "");
    setGTagManagerSendTo(settings.gTagManagerSendTo || "");
    setGtagManagerEvent(settings.gtagManagerEvent || "");
    setGtagManagerValue(!!settings.enableGtagManagerValue);
    setGTagManagerTransactionId(!!settings.enableGTagManagerTranscationId);
    setIsTagManagerEnabled(!!settings.enableTagManager);
    setTagManagerId(settings.tagManagerId || "");
  };

  useEffect(() => {
    if (appSettings) {
      applyTagManagerSettings(appSettings);
    }
  }, [appSettings]);

  useEffect(() => {
    if (isTagManagerDataLayerEnabled) {
      const tagManagerArgs = {
        dataLayer: {
          event: showGtagManagerEvent,
          send_to: showGTagManagerSendTo,
          value: showPrice,
          currency: showGTagManagerCurrency,
          transaction_id: showDbId,
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  }, [isTagManagerDataLayerEnabled]);

  useEffect(() => {
    if (isTagManagerEnabled && tagManagerId != "") {
      const tagManagerArgs = {
        gtmId: tagManagerId,
      };
      TagManager.initialize(tagManagerArgs); // google tag manager integrated along with the preferences
    }
  }, [tagManagerId, isTagManagerEnabled]);

  const nexiPageRedirectionUrl: NexiChargeTransactionDetails = {
    amount: searchParams.get("importo") || "",
    mac: searchParams.get("mac") || "",
    codAut: searchParams.get("codAut") || "",
    api_key: searchParams.get("alias") || "",
    deviceId: searchParams.get("codAut") || "",
    data: searchParams.get("data") || "",
    orario: searchParams.get("orario") || "",
    regione: searchParams.get("regione") || "",
    nazionalita: searchParams.get("nazionalita") || "",
    tipoProdotto: searchParams.get("tipoProdotto") || "",
    ppo: searchParams.get("ppo") || "",
    codiceConvenzione: searchParams.get("codiceConvenzione") || "",
    brand: searchParams.get("brand") || "",
    tipoTransazione: searchParams.get("tipoTransazione") || "",
    pan: searchParams.get("pan") || "",
    num_contratto: searchParams.get("num_contratto") || "",
    scadenza_pan: searchParams.get("scadenza_pan") || "",
    codTrans: searchParams.get("codTrans") || "",
    tipo_servizio: searchParams.get("tipo_servizio") || "",
    alreadyChargedAndBilled: "false",
  };
  const [selectedVehicleImage, setSelectedVehicleImage] = useState<string>("");
  useEffect(() => {
    const savePayment = async () => {
      try {
        const response = await BookingApi.savePaymentForNexi(
          nexiPageRedirectionUrl
        );
        setSelectedVehicleImage(response?.data?.vehicleImage);
      } catch (error) {
        console.error("Error saving payment:", error);
      }
    };

    savePayment();
  }, [nexiPageRedirectionUrl]);

  return (
    <section
      className={`min-h-[80vh] box-border flex flex-col border-t-2 border-solid border-grey-300 ${
        !isSmallScreen ? "px-44" : ""
      }`}
      style={{
        minHeight: "100vh",
        width: "100%",
        backgroundImage: `url(${selectedVehicleImage})`,
        backgroundPosition: "center",
        backgroundColor: "black",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <header className="grow flex flex-col gap-4 box-border py-8">
        <h1
          className="text-3xl font-bold text-[#FFFFFF] py-2"
          style={{
            fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
            fontSize: "48px",
          }}
        >
          {t("Congratulations!")}
        </h1>
        <h1
          className="text-3xl font-bold text-[#FFFFFF] py-2"
          style={{
            fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
            fontSize: "48px",
          }}
        >
          {t("Your Reservation Has Been Succesfull")}
        </h1>
        <h1
          className="text-[#FFFFFF] py-2"
          style={{
            fontFamily: "MBCorpoSText-Regular-Web-new",
            fontSize: "28px",
          }}
        >
          {t("You can check it on your Personal Area ")}
        </h1>
        <div className="flex flex-col-2 ">
          {" "}
          <AppStandardButton
            href="/embed"
            className={"w-fit py-4 mx-8"}
            fontFamily="MBCorpoSText-CondRegular-Web"
            variant="outlined"
            color="white"
            style={{ borderRadius: "5", width: "134.87px", height: "40.64px" }}
          >
            {/* Go to Account */}
            <span className="normal-case text-[#FFFFFF] p-1 text-lg">
              {" "}
              Homepage
            </span>
          </AppStandardButton>
          <AppStandardButton
            href="/myReservedBookings"
            className={"w-fit py-4 mx-8"}
            fontFamily="MBCorpoSText-CondRegular-Web"
            color="primary"
            variant="contained"
            style={{ borderRadius: "5", width: "162.45px", height: "40.64px" }}
          >
            <span className="normal-case text-[#FFFFF] p-1 text-lg">
              {" "}
              My Profile
            </span>
          </AppStandardButton>
        </div>
      </header>
      <main></main>
      <footer className="text-gray-600 box-border pb-32">
        <div className="box-border border-2 border-solid border-grey-200 px-8"></div>
      </footer>
    </section>
  );
}
